import React from 'react';
import Header from '../components/layout/header';

import Footerr from '../components/layout/footer';
import { useState } from 'react';
import Preloader from '../components/common/preloader';
import Sec1gallery from '../sections/sec1-gallery';
import Sec2gallery from '../sections/sec2-gallery';




const Gallery = () => {

        const [loading, setLoading] = useState(true);

    return ( 
        <>
                 {loading && <Preloader onFinish={() => setLoading(false)} />}
            <main className='body-bg'>
                <Header />
                <Sec1gallery loading={loading} />
                <Sec2gallery />
            </main>
            <Footerr />
        </>
     );
}
 
export default Gallery;